// PG(포트원) 응답의 code/message 해석 유틸.

// 사용자가 결제창을 닫은 것은 실패가 아니다. PG마다 코드가 달라 문구로 판별한다.
// (포트원+KG는 code='FAILURE_TYPE_PG', message='사용자가 빌링키 발급을 취소하였습니다')
export const isUserCancel = (code, message) => {
    const t = `${code || ''} ${message || ''}`.toLowerCase();
    return t.includes('취소') || t.includes('cancel');
};

// code 가 message 에 이미 포함된 경우 중복 표기를 피한다.
export const formatPgError = (code, message, fallback) => {
    const msg = (message || '').trim();
    const c = (code || '').trim();
    if (!msg) return c ? `${c}: ${fallback}` : fallback;
    return !c || msg.includes(c) ? msg : `${c}: ${msg}`;
};
